import React from 'react'
import UnderConstruction from '../../components/underConstruction/UnderConstruction'
import './about.css'
function About() {
    return (
     <UnderConstruction/> 
    )
}

export default About
